import Vue from 'vue'
import App from './App.vue'
import 'bootswatch/dist/sandstone/bootstrap.min.css';
import 'bootstrap';
import router from './router'
import vmodal from 'vue-js-modal'

Vue.use(vmodal)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

